module.exports = function() {
  return new Worker("/" + "unzip_imgs.worker.c83627eb0d285ebb9e3c.js");
};